<div>{{ 'PROVIDER_SEARCH_RESULT_LBL' | translate }}:</div>
<div style="padding-top: 8px">
	<div *ngFor="let provider of data" style="padding-top: 8px">
		<div style="font-size: 16px">
			<b>{{ provider.name | uppercase }}</b>
		</div>
		<span class="clickable-text" (click)="presentSpecialtiesModal(provider.specialties, true)"
			>{{ 'SPECIALTIES_LBL' | translate }} ({{ provider.specialties?.length }})</span
		>
		<div>{{ provider.healthPlan?.name }}</div>
	</div>
</div>
